import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchVeteranInfo } from '../actions/FetchVetInfoAction'

export class SearchBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchValue: '',
      searchValid: true,
      invalidMessage: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInvalid = this.handleInvalid.bind(this)
  }

  handleChange(event) {
    this.setState({
      searchValue: event.target.value,
      searchValid: true
    })
  }

  handleSubmit(event) {
    event.preventDefault()

    this.props.fetchVeteranInfo(this.state.searchValue)
    this.setState({ searchValue: '' })
  }

  handleInvalid(event) {
    event.preventDefault()

    if (event.target.value === '') {
      this.setState({
        invalidMessage: 'Invalid search: This field is required.',
        searchValid: false
      })
    }
    else {
      this.setState({
        invalidMessage: 'Invalid search: Only digits (0-9) and dashes (-) are allowed.',
        searchValid: false
      })
    }
  }

  render() {
    return (
      <div className='vis-search-bar'>
        <form className='usa-search' onSubmit={this.handleSubmit}>
          <label htmlFor='search'>
            Search by SSN or file number:
            </label>
          <input
            className='usa-search-input'
            id='search'
            type='password'
            value={this.state.searchValue}
            onChange={this.handleChange}
            pattern='[0-9-]*'
            required
            onInvalid={this.handleInvalid} />
          <button type='submit' aria-label='Search Submit'>
            <span className='usa-search-submit-text'>Search</span>
          </button>
          <span className="usa-input-error-message" id="input-error-message" role="alert" hidden={this.state.searchValid}>
            {this.state.invalidMessage}
          </span>
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchVeteranInfo }, dispatch)
}

export default connect(null, mapDispatchToProps)(SearchBar)
